// Trilingual content for the "¿Conoces Polonia?" adaptation guide page.
const POLAND = {
  es: {
    back: "Volver al inicio",
    hero: {
      badge: "Guía completa de adaptación",
      title: "¿Ya conoces Polonia?",
      subtitle: "Todo lo que necesitas saber antes de viajar: clima, qué llevar, transporte, cómo vive la gente y las oportunidades que te esperan.",
    },
    factsTitle: "Polonia de un vistazo",
    facts: [
      { k: "Capital", v: "Varsovia (Warszawa)" },
      { k: "Población", v: "~38 millones" },
      { k: "Moneda", v: "Złoty polaco (PLN)" },
      { k: "Idioma", v: "Polaco (con inglés en ciudades)" },
      { k: "Huso horario", v: "CET (UTC+1)" },
      { k: "Unión Europea", v: "Sí · zona Schengen" },
    ],
    climateTitle: "El clima y las 4 estaciones",
    climateIntro: "Polonia tiene un clima templado con cuatro estaciones muy marcadas. Prepárate para inviernos fríos y veranos agradables.",
    seasons: [
      { name: "Primavera (Mar–May)", temp: "5°C a 15°C", desc: "Templado, florece todo, lluvias ocasionales." },
      { name: "Verano (Jun–Ago)", temp: "20°C a 30°C", desc: "Cálido y soleado, días largos, ideal para pasear." },
      { name: "Otoño (Sep–Nov)", temp: "5°C a 15°C", desc: "Fresco, hojas doradas, empieza el frío." },
      { name: "Invierno (Dic–Feb)", temp: "-5°C a 3°C", desc: "Frío y con nieve. Necesitarás ropa de abrigo." },
    ],
    bringTitle: "¿Qué necesitas llevar?",
    bring: [
      { title: "Documentos", items: ["Pasaporte vigente", "Contrato de trabajo", "Copias impresas y digitales", "Fotos tamaño pasaporte"] },
      { title: "Ropa", items: ["Abrigo grueso y chamarra impermeable", "Botas y ropa térmica (invierno)", "Guantes, gorro y bufanda", "Ropa ligera para el verano"] },
      { title: "Esenciales", items: ["Adaptador de enchufe (tipo E)", "Medicamentos personales", "Algo de efectivo en PLN", "Tarjeta bancaria internacional"] },
    ],
    transportTitle: "Cómo moverte en Polonia",
    transportIntro: "El transporte público es puntual, seguro y económico. Con una app en el teléfono te mueves por todo el país.",
    transport: [
      { name: "Tren (PKP Intercity)", desc: "Red nacional cómoda y barata para viajar entre ciudades." },
      { name: "Autobús (FlixBus, PKS)", desc: "Conexiones económicas a pueblos y ciudades." },
      { name: "Tranvía y autobús urbano", desc: "En cada ciudad; boletos por app o máquina." },
      { name: "Metro (Varsovia)", desc: "Rápido y sencillo en la capital." },
      { name: "App Jakdojade", desc: "Te arma la mejor ruta de transporte público." },
      { name: "Bolt / Uber / FREE NOW", desc: "Taxis por app, prácticos y accesibles." },
    ],
    lifeTitle: "Así vive la gente",
    lifeText: [
      "Las ciudades polacas son limpias, seguras y con excelente calidad de vida. Encontrarás centros históricos preciosos, parques, centros comerciales y todo lo que necesitas cerca.",
      "Ya hay comunidades de latinos y mexicanos que te reciben. La comida es rica (prueba los pierogi), la vida fuera de las grandes capitales es asequible y la gente es tranquila y respetuosa.",
    ],
    photosTitle: "Postales de Polonia",
    oppTitle: "Las oportunidades que te esperan",
    opp: [
      { title: "Trabajo estable y legal", desc: "Contrato en regla, con horas extra para ganar más." },
      { title: "Ahorra y envía a casa", desc: "Sueldo en euros/złoty que rinde para tu familia." },
      { title: "Aprende idiomas", desc: "Mejora tu inglés y algo de polaco: más sueldo y más futuro." },
      { title: "Viaja por Europa", desc: "Desde Polonia recorres la zona Schengen fácilmente." },
    ],
    adaptTitle: "Guía rápida de adaptación",
    adaptTips: [
      { title: "Aprende frases básicas", desc: "Con saludar y dar las gracias en polaco ya ganas simpatía." },
      { title: "Usa apps de traducción", desc: "Google Translate offline te salva en el súper y el banco." },
      { title: "Abre una cuenta bancaria", desc: "Te ayudamos a abrir cuenta y sacar tu número (PESEL)." },
      { title: "Únete a la comunidad", desc: "Grupos de latinos en Polonia para dudas y amistad." },
    ],
    phrasesTitle: "Polaco para empezar",
    phrases: [
      { pl: "Dzień dobry", m: "Buenos días" },
      { pl: "Dziękuję", m: "Gracias" },
      { pl: "Proszę", m: "Por favor / de nada" },
      { pl: "Przepraszam", m: "Perdón / disculpe" },
      { pl: "Tak / Nie", m: "Sí / No" },
      { pl: "Ile to kosztuje?", m: "¿Cuánto cuesta?" },
    ],
    moneyTitle: "Tu dinero en Polonia",
    moneyIntro: "Cuánto ganas, cuánto gastas y cuánto puedes ahorrar y enviar a casa cada mes.",
    money: [
      { k: "Sueldo mensual (mínimo)", v: "≈ 4,000–5,000 PLN", note: "~$23,530 MXN por 200 horas." },
      { k: "Con horas extra", v: "6,000 PLN o más", note: "Puedes superar los $30,000 MXN al mes." },
      { k: "Alojamiento", v: "Incluido / subvencionado", note: "En la mayoría de vacantes ya viene incluido." },
      { k: "Comida al mes", v: "≈ 600–900 PLN", note: "Cocinando en casa gastas mucho menos." },
      { k: "Transporte", v: "≈ 100–150 PLN", note: "Abono mensual de tranvía y autobús." },
      { k: "Ahorro posible", v: "hasta 50% del sueldo", note: "Muchos latinos envían dinero a casa cada mes." },
    ],
    workTitle: "Tu día a día en el trabajo",
    workIntro: "Así es trabajar en un centro logístico o de producción en Polonia.",
    work: [
      { title: "Coordinadores en español", desc: "Siempre hay alguien que te explica todo en tu idioma." },
      { title: "Turnos rotativos", desc: "Mañana, tarde o noche; las horas extra son opcionales y se pagan más." },
      { title: "Transporte al trabajo", desc: "Autobús de la empresa del alojamiento a la planta." },
      { title: "Ambiente seguro", desc: "Equipo de protección y capacitación desde el primer día." },
      { title: "Comedor y descansos", desc: "Pausas y zona de comida dentro de la planta." },
      { title: "Posibilidad de crecer", desc: "Con inglés o polaco puedes subir de puesto y de sueldo." },
    ],
    foodTitle: "La comida que vas a probar",
    foodIntro: "Rica, abundante y económica. Y sí, también encuentras sabor latino.",
    food: [
      { name: "Pierogi", desc: "Empanaditas rellenas de papa, queso o carne. ¡Adictivas!" },
      { name: "Żurek", desc: "Sopa agria servida en pan; típica y calientita." },
      { name: "Bigos", desc: "Guiso de col y carne, perfecto para el invierno." },
      { name: "Kiełbasa", desc: "Salchicha polaca a la parrilla, muy popular." },
      { name: "Placki ziemniaczane", desc: "Tortitas de papa fritas, como en casa." },
      { name: "Sabor latino", desc: "Hay tiendas y restaurantes latinos en las grandes ciudades." },
    ],
    safetyTitle: "Seguridad y salud",
    safety: [
      { title: "Ciudades seguras", desc: "Polonia es de los países más seguros de Europa; sales tranquilo." },
      { title: "Emergencias: 112", desc: "Un solo número para policía, ambulancia y bomberos." },
      { title: "Salud pública (NFZ)", desc: "Con tu contrato tienes acceso al sistema público de salud." },
      { title: "Seguro de trabajo", desc: "Estás asegurado por ley mientras trabajas con contrato." },
    ],
    faqTitle: "Preguntas frecuentes",
    faq: [
      { q: "¿Necesito hablar polaco o inglés?", a: "No es obligatorio. Hay coordinadores en español y te ayudamos con lo básico." },
      { q: "¿El vuelo y el alojamiento son gratis?", a: "El vuelo es financiado y el alojamiento viene incluido o subvencionado según la vacante. Te explicamos cada caso." },
      { q: "¿Cuánto tarda el proceso?", a: "Normalmente entre 3 y 8 semanas desde tu solicitud hasta viajar, según tu pasaporte y la vacante." },
      { q: "¿Necesito experiencia previa?", a: "No. La mayoría de vacantes no la requieren; te capacitan al llegar." },
      { q: "¿Puedo ahorrar y enviar dinero a casa?", a: "Sí. Muchos envían entre el 30% y 50% de su sueldo cada mes." },
      { q: "¿Y si tengo un problema allá?", a: "Nunca estás solo: el equipo te acompaña con documentos, banco, salud y cualquier duda." },
    ],
    ctaTitle: "¿List@ para tu nueva vida en Europa?",
    ctaDesc: "Da el primer paso hoy. Nosotros te acompañamos en todo el proceso.",
    ctaBtn: "Aplicar ahora",
  },

  en: {
    back: "Back to home",
    hero: {
      badge: "Complete adaptation guide",
      title: "Do you know Poland yet?",
      subtitle: "Everything you need to know before you travel: climate, what to pack, transport, how people live and the opportunities waiting for you.",
    },
    factsTitle: "Poland at a glance",
    facts: [
      { k: "Capital", v: "Warsaw (Warszawa)" },
      { k: "Population", v: "~38 million" },
      { k: "Currency", v: "Polish Złoty (PLN)" },
      { k: "Language", v: "Polish (English in cities)" },
      { k: "Time zone", v: "CET (UTC+1)" },
      { k: "European Union", v: "Yes · Schengen area" },
    ],
    factsTitle2: "",
    climateTitle: "Climate and the 4 seasons",
    climateIntro: "Poland has a temperate climate with four distinct seasons. Be ready for cold winters and pleasant summers.",
    seasons: [
      { name: "Spring (Mar–May)", temp: "5°C to 15°C", desc: "Mild, everything blooms, occasional rain." },
      { name: "Summer (Jun–Aug)", temp: "20°C to 30°C", desc: "Warm and sunny, long days, great for walks." },
      { name: "Autumn (Sep–Nov)", temp: "5°C to 15°C", desc: "Cool, golden leaves, cold sets in." },
      { name: "Winter (Dec–Feb)", temp: "-5°C to 3°C", desc: "Cold and snowy. You'll need warm clothing." },
    ],
    bringTitle: "What should you bring?",
    bring: [
      { title: "Documents", items: ["Valid passport", "Work contract", "Printed and digital copies", "Passport-size photos"] },
      { title: "Clothing", items: ["Thick coat and waterproof jacket", "Boots and thermal wear (winter)", "Gloves, hat and scarf", "Light clothes for summer"] },
      { title: "Essentials", items: ["Plug adapter (type E)", "Personal medication", "Some cash in PLN", "International bank card"] },
    ],
    transportTitle: "Getting around Poland",
    transportIntro: "Public transport is punctual, safe and affordable. With one app on your phone you can travel the whole country.",
    transport: [
      { name: "Train (PKP Intercity)", desc: "Comfortable, cheap national network between cities." },
      { name: "Bus (FlixBus, PKS)", desc: "Affordable connections to towns and cities." },
      { name: "Tram & city bus", desc: "In every city; tickets via app or machine." },
      { name: "Metro (Warsaw)", desc: "Fast and simple in the capital." },
      { name: "Jakdojade app", desc: "Builds the best public-transport route for you." },
      { name: "Bolt / Uber / FREE NOW", desc: "Ride-hailing taxis, handy and affordable." },
    ],
    lifeTitle: "This is how people live",
    lifeText: [
      "Polish cities are clean, safe and offer an excellent quality of life. You'll find beautiful historic centers, parks, shopping malls and everything you need nearby.",
      "There are already Latino and Mexican communities to welcome you. The food is great (try pierogi), life outside the big capitals is affordable, and people are calm and respectful.",
    ],
    photosTitle: "Postcards from Poland",
    oppTitle: "The opportunities waiting for you",
    opp: [
      { title: "Stable, legal work", desc: "A proper contract, with overtime to earn more." },
      { title: "Save and send home", desc: "Euro/złoty wages that go far for your family." },
      { title: "Learn languages", desc: "Improve your English and some Polish: more pay, more future." },
      { title: "Travel across Europe", desc: "From Poland you can explore the Schengen area easily." },
    ],
    adaptTitle: "Quick adaptation guide",
    adaptTips: [
      { title: "Learn basic phrases", desc: "Greeting and saying thanks in Polish already wins hearts." },
      { title: "Use translation apps", desc: "Offline Google Translate saves you at the shop and bank." },
      { title: "Open a bank account", desc: "We help you open an account and get your number (PESEL)." },
      { title: "Join the community", desc: "Latino groups in Poland for questions and friendship." },
    ],
    phrasesTitle: "Polish to get started",
    phrases: [
      { pl: "Dzień dobry", m: "Good morning" },
      { pl: "Dziękuję", m: "Thank you" },
      { pl: "Proszę", m: "Please / you're welcome" },
      { pl: "Przepraszam", m: "Sorry / excuse me" },
      { pl: "Tak / Nie", m: "Yes / No" },
      { pl: "Ile to kosztuje?", m: "How much is it?" },
    ],
    moneyTitle: "Your money in Poland",
    moneyIntro: "How much you earn, how much you spend and how much you can save and send home each month.",
    money: [
      { k: "Monthly wage (minimum)", v: "≈ 4,000–5,000 PLN", note: "~$23,530 MXN for 200 hours." },
      { k: "With overtime", v: "6,000 PLN or more", note: "You can pass $30,000 MXN a month." },
      { k: "Housing", v: "Included / subsidised", note: "Included in most job offers." },
      { k: "Food per month", v: "≈ 600–900 PLN", note: "Cooking at home costs much less." },
      { k: "Transport", v: "≈ 100–150 PLN", note: "Monthly tram & bus pass." },
      { k: "Possible savings", v: "up to 50% of your wage", note: "Many Latinos send money home every month." },
    ],
    workTitle: "Your day-to-day at work",
    workIntro: "What it's like to work in a logistics or production centre in Poland.",
    work: [
      { title: "Spanish-speaking coordinators", desc: "There's always someone to explain everything in your language." },
      { title: "Rotating shifts", desc: "Morning, afternoon or night; overtime is optional and pays more." },
      { title: "Transport to work", desc: "Company bus from your housing to the plant." },
      { title: "Safe environment", desc: "Protective equipment and training from day one." },
      { title: "Canteen & breaks", desc: "Breaks and a food area inside the plant." },
      { title: "Room to grow", desc: "With English or Polish you can move up in role and pay." },
    ],
    foodTitle: "The food you'll try",
    foodIntro: "Tasty, filling and cheap. And yes, you'll also find Latino flavours.",
    food: [
      { name: "Pierogi", desc: "Little dumplings filled with potato, cheese or meat. Addictive!" },
      { name: "Żurek", desc: "Sour soup served in bread; classic and warming." },
      { name: "Bigos", desc: "Cabbage and meat stew, perfect for winter." },
      { name: "Kiełbasa", desc: "Grilled Polish sausage, very popular." },
      { name: "Placki ziemniaczane", desc: "Fried potato pancakes, just like home." },
      { name: "Latino flavour", desc: "There are Latino shops and restaurants in the big cities." },
    ],
    safetyTitle: "Safety and health",
    safety: [
      { title: "Safe cities", desc: "Poland is one of the safest countries in Europe; you can go out with peace of mind." },
      { title: "Emergencies: 112", desc: "One number for police, ambulance and fire brigade." },
      { title: "Public health (NFZ)", desc: "With your contract you have access to the public health system." },
      { title: "Work insurance", desc: "You are insured by law while working under contract." },
    ],
    faqTitle: "Frequently asked questions",
    faq: [
      { q: "Do I need to speak Polish or English?", a: "It's not required. There are Spanish-speaking coordinators and we help you with the basics." },
      { q: "Are the flight and housing free?", a: "The flight is financed and housing is included or subsidised depending on the job. We explain each case." },
      { q: "How long does the process take?", a: "Usually 3 to 8 weeks from your application to travel, depending on your passport and the job." },
      { q: "Do I need previous experience?", a: "No. Most jobs don't require it; you're trained on arrival." },
      { q: "Can I save and send money home?", a: "Yes. Many send between 30% and 50% of their wage every month." },
      { q: "What if I have a problem there?", a: "You're never alone: the team supports you with documents, bank, health and any question." },
    ],
    ctaTitle: "Ready for your new life in Europe?",
    ctaDesc: "Take the first step today. We guide you through the whole process.",
    ctaBtn: "Apply now",
  },

  pl: {
    back: "Powrót na stronę główną",
    hero: {
      badge: "Kompletny przewodnik adaptacyjny",
      title: "Czy znasz już Polskę?",
      subtitle: "Wszystko, co musisz wiedzieć przed wyjazdem: klimat, co zabrać, transport, jak żyją ludzie i jakie czekają na Ciebie możliwości.",
    },
    factsTitle: "Polska w skrócie",
    facts: [
      { k: "Stolica", v: "Warszawa" },
      { k: "Ludność", v: "~38 milionów" },
      { k: "Waluta", v: "Polski złoty (PLN)" },
      { k: "Język", v: "Polski (angielski w miastach)" },
      { k: "Strefa czasowa", v: "CET (UTC+1)" },
      { k: "Unia Europejska", v: "Tak · strefa Schengen" },
    ],
    climateTitle: "Klimat i 4 pory roku",
    climateIntro: "Polska ma klimat umiarkowany z czterema wyraźnymi porami roku. Przygotuj się na mroźne zimy i przyjemne lata.",
    seasons: [
      { name: "Wiosna (mar–maj)", temp: "5°C do 15°C", desc: "Łagodnie, wszystko kwitnie, okazjonalne deszcze." },
      { name: "Lato (cze–sie)", temp: "20°C do 30°C", desc: "Ciepło i słonecznie, długie dni, idealne na spacery." },
      { name: "Jesień (wrz–lis)", temp: "5°C do 15°C", desc: "Chłodno, złote liście, nadchodzi zimno." },
      { name: "Zima (gru–lut)", temp: "-5°C do 3°C", desc: "Zimno i śnieżnie. Potrzebne ciepłe ubrania." },
    ],
    bringTitle: "Co warto zabrać?",
    bring: [
      { title: "Dokumenty", items: ["Ważny paszport", "Umowa o pracę", "Kopie papierowe i cyfrowe", "Zdjęcia paszportowe"] },
      { title: "Ubrania", items: ["Gruby płaszcz i kurtka przeciwdeszczowa", "Buty i bielizna termiczna (zima)", "Rękawiczki, czapka i szalik", "Lekkie ubrania na lato"] },
      { title: "Niezbędnik", items: ["Adapter wtyczki (typ E)", "Leki osobiste", "Trochę gotówki w PLN", "Międzynarodowa karta bankowa"] },
    ],
    transportTitle: "Jak się poruszać po Polsce",
    transportIntro: "Transport publiczny jest punktualny, bezpieczny i tani. Z jedną aplikacją w telefonie przejedziesz cały kraj.",
    transport: [
      { name: "Pociąg (PKP Intercity)", desc: "Wygodna, tania sieć krajowa między miastami." },
      { name: "Autobus (FlixBus, PKS)", desc: "Tanie połączenia do miast i miasteczek." },
      { name: "Tramwaj i autobus miejski", desc: "W każdym mieście; bilety w aplikacji lub automacie." },
      { name: "Metro (Warszawa)", desc: "Szybko i prosto w stolicy." },
      { name: "Aplikacja Jakdojade", desc: "Ułoży najlepszą trasę komunikacją miejską." },
      { name: "Bolt / Uber / FREE NOW", desc: "Taksówki na aplikację, wygodne i tanie." },
    ],
    lifeTitle: "Tak żyją ludzie",
    lifeText: [
      "Polskie miasta są czyste, bezpieczne i oferują wysoką jakość życia. Znajdziesz piękne stare miasta, parki, centra handlowe i wszystko w pobliżu.",
      "Są już społeczności Latynosów i Meksykanów, które Cię przyjmą. Jedzenie jest pyszne (spróbuj pierogów), życie poza wielkimi stolicami jest przystępne, a ludzie spokojni i uprzejmi.",
    ],
    photosTitle: "Pocztówki z Polski",
    oppTitle: "Możliwości, które na Ciebie czekają",
    opp: [
      { title: "Stabilna, legalna praca", desc: "Umowa w porządku, z nadgodzinami by zarobić więcej." },
      { title: "Oszczędzaj i wysyłaj do domu", desc: "Wynagrodzenie w euro/złotych, które wystarcza dla rodziny." },
      { title: "Ucz się języków", desc: "Popraw angielski i trochę polskiego: więcej pensji i przyszłości." },
      { title: "Podróżuj po Europie", desc: "Z Polski łatwo zwiedzisz strefę Schengen." },
    ],
    adaptTitle: "Szybki przewodnik adaptacyjny",
    adaptTips: [
      { title: "Naucz się podstaw", desc: "Powitanie i podziękowanie po polsku od razu zjednuje ludzi." },
      { title: "Używaj tłumacza", desc: "Google Translate offline pomoże w sklepie i banku." },
      { title: "Załóż konto w banku", desc: "Pomożemy założyć konto i uzyskać numer (PESEL)." },
      { title: "Dołącz do społeczności", desc: "Grupy Latynosów w Polsce — pytania i przyjaźnie." },
    ],
    phrasesTitle: "Polski na start",
    phrases: [
      { pl: "Dzień dobry", m: "Powitanie w ciągu dnia" },
      { pl: "Dziękuję", m: "Podziękowanie" },
      { pl: "Proszę", m: "Prośba / proszę bardzo" },
      { pl: "Przepraszam", m: "Przeprosiny" },
      { pl: "Tak / Nie", m: "Potwierdzenie / zaprzeczenie" },
      { pl: "Ile to kosztuje?", m: "Pytanie o cenę" },
    ],
    moneyTitle: "Twoje pieniądze w Polsce",
    moneyIntro: "Ile zarabiasz, ile wydajesz i ile możesz zaoszczędzić oraz wysłać do domu co miesiąc.",
    money: [
      { k: "Pensja miesięczna (minimum)", v: "≈ 4 000–5 000 PLN", note: "~$23,530 MXN za 200 godzin." },
      { k: "Z nadgodzinami", v: "6 000 PLN lub więcej", note: "Możesz przekroczyć $30,000 MXN miesięcznie." },
      { k: "Zakwaterowanie", v: "W cenie / dofinansowane", note: "W większości ofert już wliczone." },
      { k: "Jedzenie na miesiąc", v: "≈ 600–900 PLN", note: "Gotując w domu wydajesz dużo mniej." },
      { k: "Transport", v: "≈ 100–150 PLN", note: "Miesięczny bilet na tramwaj i autobus." },
      { k: "Możliwe oszczędności", v: "do 50% pensji", note: "Wielu Latynosów co miesiąc wysyła pieniądze do domu." },
    ],
    workTitle: "Twój dzień w pracy",
    workIntro: "Jak wygląda praca w centrum logistycznym lub produkcyjnym w Polsce.",
    work: [
      { title: "Koordynatorzy po hiszpańsku", desc: "Zawsze jest ktoś, kto wszystko wytłumaczy w Twoim języku." },
      { title: "Zmiany rotacyjne", desc: "Rano, popołudnie lub noc; nadgodziny są opcjonalne i lepiej płatne." },
      { title: "Transport do pracy", desc: "Autobus firmowy z zakwaterowania do zakładu." },
      { title: "Bezpieczne środowisko", desc: "Sprzęt ochronny i szkolenie od pierwszego dnia." },
      { title: "Stołówka i przerwy", desc: "Przerwy i strefa jedzenia na terenie zakładu." },
      { title: "Możliwość awansu", desc: "Z angielskim lub polskim awansujesz na wyższe stanowisko i pensję." },
    ],
    foodTitle: "Jedzenie, którego spróbujesz",
    foodIntro: "Smaczne, sycące i tanie. I tak, znajdziesz też latynoskie smaki.",
    food: [
      { name: "Pierogi", desc: "Nadziewane ziemniakami, serem lub mięsem. Uzależniają!" },
      { name: "Żurek", desc: "Kwaśna zupa podawana w chlebie; klasyka, rozgrzewa." },
      { name: "Bigos", desc: "Duszona kapusta z mięsem, idealny na zimę." },
      { name: "Kiełbasa", desc: "Grillowana polska kiełbasa, bardzo popularna." },
      { name: "Placki ziemniaczane", desc: "Smażone placki ziemniaczane, jak w domu." },
      { name: "Latynoskie smaki", desc: "W dużych miastach są latynoskie sklepy i restauracje." },
    ],
    safetyTitle: "Bezpieczeństwo i zdrowie",
    safety: [
      { title: "Bezpieczne miasta", desc: "Polska to jeden z najbezpieczniejszych krajów Europy; wychodzisz spokojnie." },
      { title: "Alarmowy: 112", desc: "Jeden numer do policji, pogotowia i straży." },
      { title: "Zdrowie publiczne (NFZ)", desc: "Z umową masz dostęp do publicznej opieki zdrowotnej." },
      { title: "Ubezpieczenie pracy", desc: "Pracując na umowie jesteś ubezpieczony zgodnie z prawem." },
    ],
    faqTitle: "Najczęstsze pytania",
    faq: [
      { q: "Czy muszę mówić po polsku lub angielsku?", a: "Nie jest to wymagane. Są koordynatorzy po hiszpańsku i pomożemy Ci z podstawami." },
      { q: "Czy lot i zakwaterowanie są darmowe?", a: "Lot jest finansowany, a zakwaterowanie wliczone lub dofinansowane w zależności od oferty. Wyjaśniamy każdy przypadek." },
      { q: "Ile trwa proces?", a: "Zwykle od 3 do 8 tygodni od zgłoszenia do wyjazdu, zależnie od paszportu i oferty." },
      { q: "Czy potrzebuję doświadczenia?", a: "Nie. Większość ofert go nie wymaga; szkolenie odbywa się na miejscu." },
      { q: "Czy mogę oszczędzać i wysyłać pieniądze do domu?", a: "Tak. Wielu wysyła 30–50% pensji co miesiąc." },
      { q: "A jeśli będę mieć problem na miejscu?", a: "Nigdy nie jesteś sam: zespół pomaga z dokumentami, bankiem, zdrowiem i każdym pytaniem." },
    ],
    ctaTitle: "Gotowy na nowe życie w Europie?",
    ctaDesc: "Zrób pierwszy krok już dziś. Przeprowadzimy Cię przez cały proces.",
    ctaBtn: "Aplikuj teraz",
  },
};

export default POLAND;
